import { Component, OnInit } from '@angular/core';
import { ExerciseService } from '../../services/exercise.service';
import { Exercise } from '../../models/exercise';
import { Asset } from '../../models/asset';
import { EExerciseSpecifications } from '../../config/EExerciseSpecifications';
import { EGroupExercises } from '../../config/EGroupExercises';
import { EEndConditionTypes } from '../../config/EEndConditionTypes';
import { AssetsService } from '../../services/assets.service';
import EAssetTypes from '../../config/AssetsType';

@Component({
  selector: 'app-exercise',
  templateUrl: './exercise.component.html',
  styleUrls: ['./exercise.component.scss']
})
export class ExerciseComponent implements OnInit {
  public ErrorMsg = '';
  public editMode: boolean;
  public specifications: any;
  public endConditionTypes: any;
  public groupExercises: any;
  public listOfExercises: Array<Exercise>;
  public listOfAssets: Array<any>;
  public listOfVideos: Array<any>;
  public listOfPictures: Array<any>;
  public editingExercise: Exercise = new Exercise();
  public assetsType: any;
  public assetTypeToAdd: string;

  constructor(private exerciseService: ExerciseService, private assetsService: AssetsService) { }

  ngOnInit() {
    this.editMode = false;
    this.listOfAssets = [];
    this.listOfVideos = [];
    this.listOfPictures = [];
    this.listOfExercises = [];
    this.editingExercise = new Exercise();
    this.editingExercise.asset = new Asset();
    this.editingExercise.asset._id = null;
    this.assetTypeToAdd = '';
    this.specifications = EExerciseSpecifications;
    this.groupExercises = EGroupExercises;
    this.assetsType = EAssetTypes;
    this.endConditionTypes = EEndConditionTypes;
    this.exerciseService.getAllExercises().then((exercises) => {
      this.listOfExercises = exercises;
      this.assetsService.getAllAssets().then((assets) => {
        this.listOfAssets = assets;
        assets.forEach(asset => {
          if (asset.type === EAssetTypes.IMAGE) {
            this.listOfPictures.push(asset);
          } else if (asset.type === EAssetTypes.VIDEO) {
            this.listOfVideos.push(asset);
          }

          this.listOfExercises.forEach(exercise => {
            if (exercise.asset === asset._id) {
              exercise.asset = asset;
            }
          });
        });
      });
    });

    this.editingExercise.specifications = [];
  }

  public addExercise() {
    if (this.editingExercise.type && this.editingExercise.specifications.length > 0) {
      if (!this.editingExercise.asset._id) {
        this.editingExercise.asset = null;
      }
      this.exerciseService.addExercise(this.editingExercise)
        .subscribe(() => { this.ngOnInit(); });
    } else {
      this.ErrorMsg = 'Name And Specifications Are Required.';
    }
  }

  public setExerciseToEdit(exercise) {
    this.editMode = true;
    this.editingExercise = exercise;
    if (!this.editingExercise.asset) {
      this.editingExercise.asset = new Asset();
      this.editingExercise.asset._id = null;
    }
    if (this.editingExercise.asset && this.editingExercise.asset.type === EAssetTypes.VIDEO) {
      this.setTypeToVideo();
    } else if (this.editingExercise.asset && this.editingExercise.asset.type === EAssetTypes.IMAGE) {
      this.setTypeToPicture();
    }
  }

  public delExercise(id) {
    this.exerciseService.delExercise(id).subscribe(() => { this.ngOnInit(); });
  }

  public editExercise() {
    if (this.editingExercise.type && this.editingExercise.specifications.length > 0) {
      if (!this.assetTypeToAdd) {
        delete this.editingExercise.asset;
      }
      this.exerciseService.editExercise(this.editingExercise)
        .subscribe(() => { this.ngOnInit(); });
    } else {
      this.ErrorMsg = 'Name And Specifications Are Required.';
    }
  }

  public quitEditingMode() {
    this.editMode = false;
    this.editingExercise = new Exercise();
    this.editingExercise.specifications = [];
  }

  public setTypeToVideo() {
    if (this.assetTypeToAdd === EAssetTypes.VIDEO) {
      this.assetTypeToAdd = null;
    } else {
      this.assetTypeToAdd = EAssetTypes.VIDEO;
    }
  }

  public setTypeToPicture() {
    if (this.assetTypeToAdd === EAssetTypes.IMAGE) {
      this.assetTypeToAdd = null;
    } else {
      this.assetTypeToAdd = EAssetTypes.IMAGE;
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/exercise/exercise.component.ts